import React from 'react';
import { ContentSection } from '../types/angelNumber';
interface MeaningCardProps {
  icon: string;
  title: string;
  children: React.ReactNode;
  accent?: boolean;
}
export function MeaningCard({
  icon,
  title,
  children,
  accent = false
}: MeaningCardProps) {
  return <section className={['glass relative overflow-hidden rounded-3xl px-5 py-5', accent ? 'border-aura/25' : ''].join(' ')} data-id="element-41" data-mp="1s6h3txa5jqrc">
      {accent && <span aria-hidden="true" className="absolute -left-12 -top-16 h-36 w-36 rounded-full" style={{
      background: 'radial-gradient(circle, rgba(139,92,246,0.30) 0%, rgba(5,6,15,0) 70%)'
    }} data-id="element-42" data-mp="1w5zp4u5vy3up" />}
      <div className="relative flex items-center gap-2.5" data-id="element-43" data-mp="2axhzocfz766o">
        <span aria-hidden="true" className="text-[15px] leading-none" data-id="element-44" data-mp="2az1gc45jnj8z">
          {icon}
        </span>
        <h3 className="text-[13px] font-semibold uppercase tracking-[0.14em] text-lav" data-id="element-45" data-mp="2fu8gj1zlu5t5">{title}</h3>
      </div>
      <div className="relative mt-3 text-[14.5px] leading-relaxed text-white/85" data-id="element-46" data-mp="2sqrt26gpup9a">{children}</div>
    </section>;
}
interface SectionCardProps {
  icon: string;
  section?: ContentSection;
  accent?: boolean;
}

/** Renders a schema content section, and nothing at all when it is empty. */
export function SectionCard({
  icon,
  section,
  accent = false
}: SectionCardProps) {
  if (!section || !section.content.trim()) return null;
  return <MeaningCard icon={icon} title={section.title} accent={accent} data-id="element-47" data-mp="3bg7wp2np6xtx">
      <p data-id="element-48" data-mp="36ig5ybyshhrb">{section.content}</p>
    </MeaningCard>;
}